import React from 'react'
import { RiAddCircleLine } from "react-icons/ri"
import { Link } from 'react-router-dom';
import Nav from '../Nav/Nav';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from "react-toastify"
import DatePicker from "react-datepicker";
import moment from "moment";

function AddMaharaj() {

    const [englishname, Setenglishname] = useState("");
    const [hindiname, Sethindiname] = useState("");
    const [image, Setimage] = useState();
    const [content, Setcontent] = useState();
    const [loading, Setloading] = useState(false);
    const navigate = useNavigate();
    const [scheduledate, setScheduledate] = useState(new Date())
    const [status, setStatus] = useState("published")
    const [showDate, setShowdate] = useState(false)
    document.title = "Add Maharaj -Jain Sadhana";

    const showSchedule = () => {
        setShowdate(!showDate)
        if (showDate === true) {
            setStatus("published")
        }
        else {
            setStatus("scheduled")
        }
    };

    const HandleAdd = async (event) => {
        Setloading(true)
        event.preventDefault();
        const formdata = new FormData()
        formdata.append("englishname", englishname)
        formdata.append("hindiname", hindiname)
        formdata.append("content", content)
        formdata.append("image", image)
        formdata.append("status", status)
        formdata.append("scheduledate", moment(scheduledate).format("YYYY-MM-DD"))
        try {
            const response = await axios.post("api/maharaj/addmaharaj", formdata)
            if (response.status === 200) {
                navigate('/menu/maharajlist')
                toast.success('Maharaj Added Successfully')
                Setloading(false)
            }

        } catch (error) {
            console.log(error?.response?.data?.message)
            setTimeout(()=>Setloading(false),1000)
        }

    }



    return (
        <div className="container-fluid mt-3">
            <div className="row me-auto w-100">
                <div className="col-lg-3 px-4">
                    <Nav TaskTitleClass="active" maharaj="text-white" />
                </div>
                <div className="col-lg-9">
                    <div className='font '>

                        {/* section 2 */}
                        <div className='container-fluid content-list-main-box mb-5' >
                            <div className=' position-relative content-box' >
                                <div className='d-flex mb-3 justify-content-between align-item-center' >
                                    <p className='list-page-title text-black'  >Add New Maharaj</p>
                                    <Link to="/menu/maharajlist" className='text-black btn button-yellow  back-list-button'>
                                        <i className='me-2' ><RiAddCircleLine /></i> List All Maharaj</Link>
                                </div>
                                <div>
                                    <form onSubmit={HandleAdd}>
                                        <div className="row employ-form-list">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <label className='label-style text-center'> English Name</label>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setenglishname(event.target.value)} className="form-control  bg-gray border border-0" id="englishname" name='englishname' placeholder="Maharaj English Name" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <label className='label-style text-center'> Hindi Name</label>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Sethindiname(event.target.value)} className="form-control  bg-gray border border-0" id="hindiname" name='hindiname' placeholder="Maharaj Hindi Name" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 text-center">
                                                        <label className='label-style'> Content</label>
                                                        <div className="mb-3">
                                                            <textarea onChange={(event) => Setcontent(event.target.value)} style={{ height: "150px" }} className="form-control  bg-gray border border-0" id="content" name='content' placeholder="Maharaj Content" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 text-center">
                                                        <label className='label-style'> Upload Image</label>
                                                        <div className=" mb-3">
                                                            <input name="image" onChange={(e) => Setimage(e.target.files[0])} type="file" className="form-control " id="upload-file" required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="align-items-center gap-2 mb-2 ">
                                                    <input type='checkbox' onClick={showSchedule} id='checkbox' />
                                                    <label className="label-style" htmlFor='checkbox'>Click on the Checkbox to Schedule </label>
                                                    {
                                                        showDate === true ? <div>
                                                            <label className="label-style d-block ms-4">Enter Schedule Date</label>
                                                            <DatePicker selected={scheduledate} minDate={new Date()} onChange={(date) => setScheduledate(date)} className="width50 form-control ms-4 border border-2 border-dark" />
                                                        </div> : ""
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex  justify-content-center align-item-center mt-3' >
                                            {
                                                loading === true ? <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Loading... </button> : <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Submit</button>
                                            }
                                            <Link to={'/menu/maharajlist'} className='btn  bg-black font-size text-white  mx-3 px-4 py-2 ' ><i className="fa-solid fa-xmark  mx-2"></i>Cancel</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AddMaharaj